// 投诉模块
import $http from '../../utils/http';
let complaintPath = '/tio/complain/v2/api/';

export const menuList = data => {//处理组首页菜单
    return $http({
        url: complaintPath + 'menu/workbechComplainCount',
        data,
        method: 'POST'
    });
};
export const syntheticalWarning= data => {//综合预警
    return $http({
        url: complaintPath + 'newWorkbench/workbench/syntheticalWarning',
        data,
        method: 'POST'
    });
};
export const emergency= data => {//紧急程度
    return $http({
        url: complaintPath + 'newWorkbench/workbench/emergency',
        data,
        method: 'POST'
    });
};
export const timeLimit= data => {//显示预警
    return $http({
        url: complaintPath + 'newWorkbench/workbench/timeLimit',
        data,
        method: 'POST'
    });
};

export const workMenuList = data => {//领导组首页菜单入口
    return $http({
        url: complaintPath + 'menu/findMenu',
        data,
        method: 'POST'
    });
};
// ----------------------------------------------------------------------------------------

export const userInfoByPhone = data => {
    // 获取首页用户信息
    return $http({
        url: complaintPath + 'currentuserinfo',
        data,
        method: 'POST'
    });
};
export const workbench = data => {
    // 获取首页用户信息
    return $http({
        url: complaintPath + 'newWorkbench/workbench',
        data,
        method: 'POST'
    });
};
export const workbenchList = data => {
    // 获取领导组列表
    return $http({
        url: complaintPath + 'newWorkbench/workbench/list',
        data,
        method: 'POST'
    });
};
export const superviseList = data => {
    // 我的督办
    return $http({
        url: complaintPath + 'supervise/list',
        data,
        method: 'POST'
    });
};
export const attentionList = data => {
    // 我的督办
    return $http({
        url: complaintPath + 'attention/list',
        data,
        method: 'POST'
    });
};
export const newWorkbenchList = data => {
    // 获取处理组列表
    return $http({
        url: complaintPath + 'newWorkbench/list',
        data,
        method: 'POST'
    });
};
export const list = params => {
    // 获取投诉列表
    return $http({
        url: complaintPath + 'query/list',
        params
    });
};

// 投诉基础详情
export const detailsInfo = params => {
    return $http({
        url: complaintPath + 'details/info',
        params
    });
};
export const dataVisualization = data => {
    // 获取首页用户信息
    return $http({
        url: complaintPath + 'display/dataVisualization',
        data,
        method: 'POST'
    });
};
// 地图区域
export const mapList = params => {
    // 获取首页用户信息
    return $http({
        url: complaintPath + 'region/list',
        params
    });
};
// 处理组首页
export const processGroup = data => {
        return $http({
            url: complaintPath + 'module/list'
        })
    }
    // 获取投诉对象的类型
export const getComplainTypeList = data => {
        return $http({
            url: complaintPath + 'base/getComplainTypeList',
            method: 'POST',
            data
        })
    }
    // 获取行政区域
export const hordeptmentList = data => {
        return $http({
            url: complaintPath + 'hordeptment/list',
            method: 'POST',
            data
        })
    }
    // 获取导游旅行社列表
export const guideAndTravelList = data => {
        return $http({
            url: complaintPath + 'guideAndTravel/list',
            method: 'POST',
            data
        })
    }
    // 上报审核通过和上报审核不通过
export const accept = data => {
        return $http({
            url: complaintPath + 'accept/operation',
            method: 'POST',
            data
        })
    }
    // 关注和取消关注
export const attention = data => {
    return $http({
        url: complaintPath + 'attention/operation',
        method: 'POST',
        data
    })
};
// 信息补充核实
export const detailsAddAnSduer = data => {
    return $http({
        url: complaintPath + 'objOfComplain/add',
        data,
        method: 'POST'
    })
};
// 确定立案
export const suerFiling = data => {
    return $http({
        url: complaintPath + 'complainToCase/operation',
        data,
        method: 'POST'
    })
};
// 不予立案
export const dontFiling = data => {
    return $http({
        url: complaintPath + 'complainToCase/operation',
        data,
        method: 'POST'
    })
};
// 绑定电子合同页面搜索
export const searchElectronicContract = data => {
    return $http({
        url: complaintPath + 'electronicContract/list',
        data,
        method: 'POST'
    })
};
export const guideAndTravelOperation = data => {
        // 导游操作接口
        return $http({
            url: complaintPath + 'guideAndTravel/operation',
            method: 'POST',
            data
        })
    }
    // 督办回复，获取草稿内容
export const detailsInfos = data => {
        return $http({
            url: complaintPath + 'details/info',
            method: 'POST',
            data
        })
    }
    // 督办回复，保存草稿
export const saveOperation = data => {
    return $http({
        url: complaintPath + 'supervise/operation',
        method: 'POST',
        data
    })
}
export const acceptList = data => {
    // 指挥中心处理列表
    return $http({
        url: complaintPath + 'accept/list',
        method: 'POST',
        data
    })
}
export const complainToCaseList = data => {
        //  诉转案待受理列表
        return $http({
            url: complaintPath + 'complainToCase/list',
            method: 'POST',
            data
        })
    }
    // 获取统计机构名称
export const transformationCenter = data => {
        return $http({
            url: complaintPath + 'transformationCenter/transformationCenter',
            method: 'POST',
            data
        })
    }
    // 申诉审核通过和不通过
export const disposeOperation = data => {
        return $http({
            url: complaintPath + 'dispose/operation',
            method: 'POST',
            data
        })
    }
    // 调节成功和调节失败基础数据维护
export const ComplainTypeList = data => {
        return $http({
            url: complaintPath + 'base/getComplainTypeList',
            method: 'POST',
            data
        })
    }
    // 分发查询
export const searchList = data => {
        return $http({
            url: complaintPath + 'base/enterprise/list',
            method: 'POST',
            data
        })
    }
    // 发起响应
export const complainResponse = data => {
        return $http({
            url: complaintPath + 'complainResponse/operation',
            method: 'POST',
            data
        })
    }
    // 获取专员手机号码
export const getVirtualNumber = data => {
        return $http({
            url: complaintPath + 'visnum/getVirtualNumber',
            method: 'POST',
            data
        })
    }
    // 保存补充材料信息
export const supplement = data => {
    return $http({
        url: complaintPath + 'supplement/saveSupplement',
        method: 'POST',
        data
    })
}

// 获取保存的补充详情
export const supplementDetail = data => {
    return $http({
        url: complaintPath + 'supplement/supplementDetail',
        method: 'POST',
        data
    })
}

// 提交补充信息
export const supplementMaterials = data => {
        return $http({
            url: complaintPath + 'supplement/supplementMaterials',
            method: 'POST',
            data
        })
    }
    // 提交补充信息
export const adminicle = data => {
    return $http({
        url: complaintPath + 'bus/adminicle',
        method: 'POST',
        data
    })
}
export const disposeList = data => {
    return $http({
        url: complaintPath + 'dispose/list',
        method: 'POST',
        data
    })
}

// 上报 指挥中心
export const aOperation = data => {
    return $http({
        url: complaintPath + 'accept/operation',
        data,
        method: 'POST'
    });
};

// 上报 类型、企业、部门
export const dOperation = data => {
    return $http({
        url: complaintPath + 'dispose/operation',
        data,
        method: 'POST'
    });
};
// 撤回
export const cancelConfirm = data => {
    return $http({
        url: complaintPath + 'revocation/operation',
        data,
        method: 'POST'
    });
};
export const assessToComplain = data => {
    return $http({
        url: complaintPath + 'assessToComplain/list',
        data,
        method: 'POST'
    });
};
export const assessToComplainDetails = data => {
    return $http({
        url: complaintPath + 'assessToComplain/details',
        data,
        method: 'POST'
    });
};
export const returnDetail = data => { // 回访单详情
    return $http({
        url: complaintPath + 'details/info',
        data,
        method: 'POST'
    });
};
export const returnAssessDetail = data => { // 考核=跳投诉回访单详情
    return $http({
        url: complaintPath + 'assessToComplain/details',
        data,
        method: 'POST'
    });
};
export const dylxsList = data => { // 导旅列表
    return $http({
        url: complaintPath + 'dylxs/queryList',
        data,
        method: 'POST'
    });
};
export default {
    workbench,
    userInfoByPhone,
    list,
    detailsInfo,
    dataVisualization,
    mapList,
    workbenchList,
    newWorkbenchList,
    processGroup,
    detailsAddAnSduer,
    dontFiling,
    suerFiling,
    searchElectronicContract,
    getComplainTypeList,
    superviseList,
    attentionList,
    guideAndTravelList,
    attention,
    accept,
    guideAndTravelOperation,
    detailsInfos,
    saveOperation,
    transformationCenter,
    disposeOperation,
    acceptList,
    complainToCaseList,
    ComplainTypeList,
    hordeptmentList,
    searchList,
    complainResponse,
    getVirtualNumber,
    supplement,
    supplementDetail,
    supplementMaterials,
    adminicle,
    disposeList,
    aOperation,
    dOperation,
    cancelConfirm,
    assessToComplain,
    assessToComplainDetails,
    returnDetail,
    returnAssessDetail,
    dylxsList,
    // ------------------------------------------------------------------
    menuList,
    workMenuList,
    syntheticalWarning,
    emergency,
    timeLimit
}